const sidebar2 = (editor) => {

    editor.BlockManager.add(`sidebar2`, {
        category: 'Sidebars',
        label: ` 
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="1.4rem" height="1.4rem" viewBox="0 0 128.000000 128.000000"
                preserveAspectRatio="xMidYMid meet">
            
            <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path class="gjs-block-svg-path" 
            d="M223 1139 c-43 -13 -80 -60 -88 -112 -3 -23 -5 -213 -3 -422 3 -418
            2 -411 65 -452 25 -16 63 -18 443 -18 380 0 418 2 443 18 63 41 62 30 62 487
            0 380 -2 418 -18 443 -41 63 -32 62 -472 64 -226 1 -414 -2 -432 -8z m227
            -499 l0 -450 -107 0 c-96 0 -109 2 -130 22 l-23 21 0 406 c0 492 -14 451 152
            451 l108 0 0 -450z m617 428 l23 -21 0 -406 c0 -402 0 -405 -22 -428 -21 -23
            -22 -23 -290 -23 l-268 0 0 450 0 450 267 0 c260 0 267 -1 290 -22z"/>
            <path class="gjs-block-svg-path" 
            d="M253 983 c-18 -7 -16 -40 3 -47 9 -3 37 -6 64 -6 27 0 55 3 64 6 21
            8 21 40 0 48 -18 7 -113 7 -131 -1z"/>
            <path class="gjs-block-svg-path"  
            d="M253 823 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            <path class="gjs-block-svg-path" 
            d="M253 663 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            </g>
            </svg>
            <div class='gjs-fontFamily gjs-block-label'>Sidebar2</div>`,
        attributes: { },
        content: `     
            <div class="container-fluid overflow-hidden">
                <div class="row vh-100 overflow-auto">
                    <div class="col-12 col-sm-3 col-xl-2 bg-dark d-flex sticky-top px-0">
                        <div class="d-flex flex-sm-column flex-row flex-grow-1 align-items-center align-items-sm-start pt-2 text-white">
                            <span href="/" class="pointer d-flex align-items-center pb-sm-3 mb-md-0 me-md-auto text-white text-decoration-none max-width px-4">
                                <span class="fs-5">B<span class="d-none d-sm-inline">rand</span></span>
                            </span>
                            <ul class="nav nav-pills flex-sm-column flex-row flex-nowrap flex-shrink-1 flex-sm-grow-0 flex-grow-1 mb-sm-auto mb-0 justify-content-center align-items-center align-items-sm-start max-width" id="menu">
                                <li class="nav-item max-width">
                                    <span href="#" class="pointer nav-link px-4">
                                        <i class="fs-5 bi-house"></i><span class="ms-1 d-none d-sm-inline">Home</span>
                                    </span>
                                </li>
                                <li class="max-width">
                                    <span href="#submenu1" data-bs-toggle="collapse" class="pointer nav-link px-4">
                                        <i class="fs-5 bi-speedometer2"></i><span class="ms-1 d-none d-sm-inline">Dashboard</span> </span>
                                </li>
                                <li class="max-width">
                                    <span href="#" class="pointer nav-link px-4">
                                        <i class="fs-5 bi-table"></i><span class="ms-1 d-none d-sm-inline">Orders</span></span>
                                </li>
                                <li class="dropdown max-width">
                                    <span href="#" class="pointer nav-link dropdown-toggle px-4" id="dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fs-5 bi-bootstrap"></i><span class="ms-1 d-none d-sm-inline">Bootstrap</span>
                                    </span>
                                    <ul class="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdown">
                                        <li><span class="pointer dropdown-item" href="#">New project...</span></li>
                                        <li><span class="pointer dropdown-item" href="#">Settings</span></li>
                                        <li><span class="pointer dropdown-item" href="#">Profile</span></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li><span class="pointer dropdown-item" href="#">Sign out</span></li>
                                    </ul>
                                </li>
                                <li class="max-width">
                                    <span href="#" class="pointer nav-link px-4">
                                        <i class="fs-5 bi-grid"></i><span class="ms-1 d-none d-sm-inline">Products</span></span>
                                </li>
                                <li class="max-width"> 
                                    <span href="#" class="pointer nav-link px-4">
                                        <i class="fs-5 bi-people"></i><span class="ms-1 d-none d-sm-inline">Customers</span> </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col d-flex flex-column h-sm-100" style="overflow-x: auto">
                        <div class="col pt-4" style="overflow-x: auto">
                            <h3>Vertical Sidebar that switches to Horizontal Navbar</h3>
                            <p class="lead">An example multi-level sidebar with collasible menu items. The menu functions like an "accordion" where only a single menu is be open at a time.</p>
                            <hr />
                            <h3>More content...</h3>
                            <p>Sriracha biodiesel taxidermy organic post-ironic, Intelligentsia salvia mustache 90's code editing brunch. Butcher polaroid VHS art party, hashtag Brooklyn deep v PBR narwhal sustainable mixtape swag wolf squid tote bag. Tote bag cronut semiotics, raw denim deep v taxidermy messenger bag. Tofu YOLO Etsy, direct trade ethical Odd Future jean shorts paleo. Forage Shoreditch tousled aesthetic irony, street art organic Bushwick artisan cliche semiotics ugh synth chillwave meditation. Shabby chic lomo plaid vinyl chambray Vice. Vice sustainable cardigan, Williamsburg master cleanse hella DIY 90's blog.</p>
                            <p>Ethical Kickstarter PBR asymmetrical lo-fi. Dreamcatcher street art Carles, stumptown gluten-free Kickstarter artisan Wes Anderson wolf pug. Godard sustainable you probably haven't heard of them, vegan farm-to-table Williamsburg slow-carb readymade disrupt deep v. Meggings seitan Wes Anderson semiotics, cliche American Apparel whatever. Helvetica cray plaid, vegan brunch Banksy leggings +1 direct trade. Wayfarers codeply PBR selfies. Banh mi McSweeney's Shoreditch selfies, forage fingerstache food truck occupy YOLO Pitchfork fixie iPhone fanny pack art party Portland.</p>
                        </div>
                        <footer class="row bg-light py-4 mt-auto">
                            <div class="col"> Footer content here... </div>
                        </footer>
                    </div>
                </div>
            </div>
        `
    });

} 

export default sidebar2;